import { schema } from 'normalizr';
import accountSchema from './accountSchema';

const contactListSchema = new schema.Entity('contactLists', {
  account: accountSchema,
  accounts: [accountSchema],
});

export default contactListSchema;
